import React from 'react';
import {connect} from 'react-redux';
import ApiActions from 'go/actions/api';
import IdleTimer from 'react-idle-timer';
import jwt_decode from 'jwt-decode';
import {calculateTimeToDelay, createDateFromSeconds} from 'go/sagas//loginSaga';
import _ from 'lodash';

const MODAL_DURATION = 5 * 60 * 1000; // 5 minutes
const THROTTLE_INTERVAL = 15 * 1000; //  15 seconds

export class IdleTimerWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.onAction = this.onAction.bind(this);
    this.onIdle = this.onIdle.bind(this);
  }

  render() {
    let returnValue = null;

    if (this.props.token && isTokenValid(this.props.token)) {
      //508 compliance requires to be 5 minutes
      const timeToTimeoutModal = MODAL_DURATION;
      returnValue = (
        <IdleTimer
          onIdle={this.onIdle}
          onAction={_.debounce(this.onAction, 5000, {maxWait: 5000})}
          timeout={timeToTimeoutModal}
          throttle={THROTTLE_INTERVAL}
        />
      );
    }
    return returnValue;
  }

  onAction = (e) => {
    this.props.refreshToken(this.props.token);
  };

  onIdle = (e) => {
    this.props.toggleTimeoutModal(true);
  };
}

export const isTokenValid = (token) => {
  var decoded = null;
  decoded = token;
  var current_time = Date.now() / 1000;
  return decoded.exp < current_time ? false : true;
};

export const mapStateToProps = (state) => {
  return {
    token: state.auth ? state.auth.token : null,
  };
};

export const mapDispatchToProps = (dispatch) => ({
  refreshToken: (token) => {
    const action = ApiActions.auth.refresh(token);
    return dispatch(action);
  },
  toggleTimeoutModal: (toggle) => {
    const action = ApiActions.auth.toggleTimeoutModal(toggle);
    return dispatch(action);
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(IdleTimerWrapper);
